<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">

      <el-form-item class="search-field fl five-per-row" label="任务名称" prop="scheduleName">
        <el-input v-model.trim="queryParams.scheduleName" placeholder="请输入任务名称" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="任务执行标识" prop="taskName">
        <el-select-dict dictType="SCHEDULE_TASK" @dictChange="handleQuery" v-model="queryParams.taskName" clearable
          placeholder="请选择任务执行标识" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="执行类型" prop="action">
        <el-select-dict dictType="ACTION_TYPE" @dictChange="handleQuery" v-model="queryParams.action" clearable
          placeholder="请选择任务执行类型" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="任务状态" prop="scheduleStatus">
        <el-select-dict dictType="STATUS" clearable placeholder="请选择任务状态" v-model="queryParams.scheduleStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="日志状态" prop="logStatus">
        <el-select-dict dictType="STATUS" clearable placeholder="请选择日志状态" v-model="queryParams.logStatus"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="执行时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['log:schedule:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>

        <el-button v-hasPermission="['log:schedule:deleteAll']" class="fr" type="danger" icon="el-icon-delete"
          size="mini" @click="handleDeleteAll">全部删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="scheduleLogTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
          v-loading="loading" :data="list" row-key="logId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
          <el-table-column label="定时器任务名称" prop="scheduleName" align="center" min-width="200px" />
          <el-table-column-dict dictType="SCHEDULE_TASK" label="任务执行标识" prop="taskName" align="center" min-width="300px"
            show-overflow-tooltip />
          <el-table-column-dict dictType="ACTION_TYPE" dictTypeNode="tag" label="执行类型" align="center" prop="action"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="cron执行表达式" prop="cron" align="center" min-width="300px" show-overflow-tooltip />
          <el-table-column-dict dictType="SCHDULE_STATUS" dictTypeNode="tag" label="定时任务状态" align="center" prop="scheduleStatus"
            min-width="128px"></el-table-column-dict>
          <el-table-column-dict dictType="SUCCESS_FAIL" dictTypeNode="tag" label="状态" align="center" prop="logStatus"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dateFormat="datetime" label="执行日期" align="center" prop="createTime"
            min-width="168px"></el-table-column-dict>
          <el-table-column v-if="
            mixinHasPermi([
              'log:schedule:read',
            ])
          " label="操作" align="center" width="128px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['log:schedule:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="getDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <schedule-log-dialog ref="scheduleLogDialog" title="日志详情" width="996px" :visible.sync="open"
      :modal-append-to-body="false" :close-on-click-modal="false" :baseForm="baseForm"
      @close="open = false"></schedule-log-dialog>
  </div>
</template>

<script>
import { logApi } from "@/api"
import ScheduleLogDialog from "./components/schedule-log-dialog.vue"
export default {
  name: "logScheduleManage",
  components: {
    ScheduleLogDialog
  },
  data() {
    return {
      //搜索条件参数
      queryParams: {
        loginUserName: "", // 登录用户名称
        loginIp: "", // 登录ip地址
        status: "", // 登录状态
        loginChannel: "", // 登录所属渠道
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,

      // 非多个禁用(0个禁用)
      multiple: true,
      selection: [], // 选中的列表数据
      
      // 表单参数
      baseForm: {
        scheduleName: "",
        taskName: "",
        cron: "",
        action: "",
        createTime: "",
        logStatus: "",
        remark: "",
        scheduleStatus: ""
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 删除全部登录日志
    handleDeleteAll() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      this.$modal
        .confirm("删除后不可找回，是否确认删除全部任务日志？")
        .then(function() {
          return logApi.deleteAllScheduleLog()
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("删除全部任务日志成功")
        })
        .catch(() => { })
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.logId)
      }

      this.$modal
        .confirm("删除后不可找回，是否确认删除已选择的数据项？")
        .then(function() {
          return logApi.batchDeleteScheduleLog({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除任务日志成功")
        })
        .catch(() => { })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.multiple = !selection.length
    },
    //点击行
    clickRow(row) {
      this.$refs.scheduleLogTable.toggleRowSelection(row)
    },
    /** 搜索按钮登录 */
    handleQuery() {
      // 清空已选项
      this.$refs.scheduleLogTable.clearSelection()
            
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮登录 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      logApi
        .getScheduleLogList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 查看详情 */
    getDetail(row) {
      const id = row.logId
      logApi.getScheduleLogDetailById({ id }).then((data) => {
        console.log("🚀 ~ logApi.getScheduleLogDetailById ~ data:", data)
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    }
  }
}
</script>
